(() => {
const root = document.querySelector('[data-wildwood-form]');
const decodeTranslation = (key,value)=>typeof value==='string'?value.replace(/&(?:amp|lt|gt|quot|#39);/g,entity=>({'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':String.fromCharCode(39)})[entity]):value;
const configs=JSON.parse(document.getElementById('wildwood-configs').textContent,decodeTranslation);
const ui=JSON.parse(document.getElementById('wildwood-ui').textContent,decodeTranslation);
const chooser=root.querySelector('[data-chooser]'),panel=root.querySelector('[data-form-panel]');
const params=new URLSearchParams(location.search), requested=params.get('request');
const starting=root.dataset.kind;
function choiceButton(text,action){const b=document.createElement('button');b.type='button';b.textContent=text;b.addEventListener('click',action);chooser.append(b);}
function pick(category){chooser.replaceChildren();const title=document.createElement('h1');title.textContent=ui[28];chooser.append(title);
choiceButton(category==='spell'?ui[29]:ui[30],()=>start(category+'_change'));
if(starting!=='order')choiceButton(category==='spell'?ui[31]:ui[32],()=>start(category==='spell'?'spell_recast':'reading_followup'));
choiceButton(ui[33],showChoices);}
function showChoices(){chooser.replaceChildren();const h=document.createElement('h1');h.textContent=ui[34];const p=document.createElement('p');p.textContent=ui[35];chooser.append(h,p);choiceButton(ui[36],()=>pick('spell'));choiceButton(ui[37],()=>pick('reading'));}
function start(kind){chooser.hidden=true;panel.hidden=false;const config=configs[kind];root.querySelector('[data-title]').textContent=config.title;root.querySelector('[data-intro]').textContent=config.intro;root.querySelector('[data-note]').textContent=config.note;
root.querySelector('[data-back]').addEventListener('click',()=>{if(!panel.querySelector('form').hidden&&[...panel.querySelectorAll('input,textarea')].some(e=>e.value)&&!window.confirm(ui[38]))return;const next=new URL(location.href);next.searchParams.delete('request');next.searchParams.set('choose','1');location.href=next.href;});
const form = root.querySelector('form');
const fields = form.querySelector('[data-fields]');
const message = root.querySelector('[role="status"]');
const button = form.querySelector('button[type="submit"]');
const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
let requestId = 'WW-' + crypto.randomUUID();
let pending = false, submitted = null, complete = false;
const el = (tag, text, attrs = {}) => {
  const element = document.createElement(tag);
  if (text) element.textContent = text;
  for (const [k,v] of Object.entries(attrs)) element.setAttribute(k,v);
  return element;
};
for (const [key,label,column,type,required,help,branch] of config.fields) {
  const group = el('div', '', {class:'ww-field'});
  if (branch) group.dataset.branch = branch;
  const id = 'ww-' + key;
  if(key==='window'){
 const picker=el('fieldset','',{class:'ww-window-options'});picker.append(el('legend',label));
 for(const [i,value] of type.entries()){const option=el('label','',{class:'ww-radio-option'});const radio=el('input','',{type:'radio',name:key,value,id:id+'-'+i});option.append(radio,el('span',value));picker.append(option);}group.append(picker);
 const timing=el('p','',{class:'ww-help','aria-live':'polite'});group.append(timing);
 picker.addEventListener('change',()=>{timing.textContent=form.elements.window.value==='Less than 30 days ago'?ui[39]:'';});
 } else if (type === 'dob') {
    const picker = el('fieldset'); picker.append(el('legend',label + ' (DD MMM YYYY)'));
    const parts = [['day',Array.from({length:31},(_,i)=>String(i+1).padStart(2,'0'))],['month',months],['year',Array.from({length:new Date().getFullYear()-1899},(_,i)=>String(new Date().getFullYear()-i))]];
    for (const [part,values] of parts) {
      const select = el('select','',{name:key+'-'+part,'aria-label':label+' — '+part,'data-date':key});
      select.append(el('option',part,{value:''}));
      for(const v of values) select.append(el('option',v,{value:v}));
      picker.append(select);
    }
    group.append(picker);
  } else if (type === 'product') {
    group.classList.add('ww-product-picker');
    group.append(el('label',label+(required?' *':''),{for:id}));
    const picker=el('div','',{class:'ww-picker'});
    const input=el('input','',{id,name:key,type:'text',role:'combobox','aria-autocomplete':'list','aria-expanded':'false','aria-controls':id+'-options',autocomplete:'off',placeholder:ui[15]});
    input.required=!!required; input.maxLength=320;
    const toggle=el('button','⌄',{type:'button',class:'ww-picker-toggle','aria-label':ui[16],'aria-controls':id+'-options','aria-expanded':'false'});
    const list=el('ul','',{id:id+'-options',role:'listbox','aria-label':label,class:'ww-picker-options'});list.hidden=true;
    const hint=el('p',ui[17],{id:id+'-search-help',class:'ww-help'});
    const count=el('p','',{'aria-live':'polite','aria-atomic':'true',class:'ww-search-count'});
    input.setAttribute('aria-describedby',hint.id);
    let matches=[],active=-1;
    const normalise=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
    const validate=()=>input.setCustomValidity(!input.value||config.products.includes(input.value)?'':ui[18]);
    const close=()=>{list.hidden=true;input.setAttribute('aria-expanded','false');toggle.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');active=-1;};
    const choose=value=>{if(input.disabled)return;input.value=value;validate();close();count.textContent='';input.focus();close();input.dispatchEvent(new Event('change',{bubbles:true}));};
    const render=(all=false)=>{
      if(input.disabled)return;
      const words=normalise(input.value).split(/\s+/).filter(Boolean);
      const filtered=config.products.filter(v=>all||words.every(w=>normalise(v).includes(w)));
      const other=config.products.find(v=>v==='Other / Not sure');
      matches=[...filtered];if(other&&!matches.includes(other))matches.push(other);
      list.replaceChildren();active=-1;input.removeAttribute('aria-activedescendant');
      for(const [i,value] of matches.entries()){
        const option=el('li',value,{id:id+'-option-'+i,role:'option','aria-selected':String(input.value===value)});
        option.addEventListener('mousedown',event=>event.preventDefault());
        option.addEventListener('click',()=>choose(value));list.append(option);
      }
      list.hidden=false;input.setAttribute('aria-expanded','true');toggle.setAttribute('aria-expanded','true');
      count.textContent=filtered.length?ui[19]:ui[20];
    };
    const move=step=>{
      if(list.hidden)render(true);
      active=active<0?(step>0?0:matches.length-1):(active+step+matches.length)%matches.length;
      for(const [i,option] of [...list.children].entries())option.setAttribute('aria-selected',String(i===active));
      const option=list.children[active];if(option){input.setAttribute('aria-activedescendant',option.id);option.scrollIntoView({block:'nearest'});}
    };
    input.addEventListener('input',()=>{validate();render();});
    input.addEventListener('focus',()=>render(config.products.includes(input.value)));
    input.addEventListener('change',validate);
    input.addEventListener('blur',close);
    input.addEventListener('keydown',event=>{
      if(event.key==='ArrowDown'||event.key==='ArrowUp'){event.preventDefault();move(event.key==='ArrowDown'?1:-1);}
      else if(event.key==='Enter'&&!list.hidden){event.preventDefault();if(active>=0)choose(matches[active]);else if(matches.length===1)choose(matches[0]);}
      else if(event.key==='Escape'){event.preventDefault();close();}
      else if(event.key==='Tab')close();
    });
    toggle.addEventListener('pointerdown',event=>event.preventDefault());
    toggle.addEventListener('click',()=>{if(input.disabled)return;if(list.hidden){input.focus();render(true);}else close();});
    picker.append(input,toggle,list);group.append(picker,hint,count);
  } else {
    group.append(el('label',label+(required?' *':''),{for:id}));
    const options = type === 'product' ? config.products : Array.isArray(type) ? type : null;
    const control = el(options?'select':type==='textarea'?'textarea':'input','',{id,name:key});
    if(options){control.append(el('option',ui[8],{value:''}));for(const v of options)control.append(el('option',v,{value:v}));}
    else if(type==='textarea'){control.rows=key.startsWith('question')?3:4;control.maxLength=6000;control.addEventListener('input',()=>{control.style.height='auto';control.style.height=control.scrollHeight+'px';});}
    else {control.type=type;control.maxLength=320;}
    if(required)control.required=true;
    if(help)control.setAttribute('aria-describedby',id+'-help');
    if(key==='name')control.autocomplete='name';
    if(key==='email')control.autocomplete='email';
    if(key==='order'){control.placeholder='#';control.inputMode='text';}
    group.append(control);
  }
  if(help)group.append(el('p',help,{id:id+'-help',class:'ww-help'}));
  fields.append(group);
}
function branch(){
 const selected = form.elements.tier?.value || '';
 for(const group of fields.querySelectorAll('[data-branch]')){
   group.hidden=group.dataset.branch!==selected;
   for(const input of group.querySelectorAll('input,select,textarea'))input.disabled=group.hidden;
 }
}
function validateDates(){
 for(const [key,,,type] of config.fields){
  if(type!=='dob')continue;
  const controls=[...fields.querySelectorAll('[data-date="'+key+'"]')];
  const parts=controls.map(control=>control.value);
  let error='';
  if(!controls[0].disabled&&parts.some(Boolean)){
   if(!parts.every(Boolean))error=ui[10];
   else{
    const date=new Date(Date.UTC(+parts[2],months.indexOf(parts[1]),+parts[0]));
    if(date.getUTCDate()!==+parts[0]||date.getUTCMonth()!==months.indexOf(parts[1])||date>new Date())error=ui[11];
   }
  }
  controls[0].setCustomValidity(error);
 }
}
form.addEventListener('change',()=>{branch();validateDates();});branch();
let validationAttempted=false, validationFocusQueued=false;
const errorSummary=el('p','',{class:'ww-error-summary',role:'alert',tabindex:'-1'});
errorSummary.hidden=true;fields.before(errorSummary);
const validationFields=[...fields.querySelectorAll('input,select,textarea')].map((control,i)=>{
 const error=el('p','',{id:'ww-field-error-'+i,class:'ww-field-error'});error.hidden=true;
 control.closest('.ww-field').append(error);
 return {control,error,description:control.getAttribute('aria-describedby')||''};
});
function showFieldErrors(){
 let count=0;
 for(const {control,error,description} of validationFields){
  const invalid=control.willValidate&&!control.validity.valid;
  let text='';
  if(invalid){
   if(control.type==='radio')continue;count++;
   if(control.dataset.date&&control.validity.customError)text=control.validationMessage;
   else if(control.name==='product')text=ui[21];
   else if(control.validity.valueMissing)text=control.name==='name'?ui[22]:control.name==='email'?ui[23]:ui[24];
   else if(control.validity.typeMismatch&&control.type==='email')text=ui[25];
   else text=ui[26];
  }
  error.textContent=text;error.hidden=!invalid;
  if(invalid){control.setAttribute('aria-invalid','true');control.setAttribute('aria-describedby',[description,error.id].filter(Boolean).join(' '));}
  else {control.removeAttribute('aria-invalid');if(description)control.setAttribute('aria-describedby',description);else control.removeAttribute('aria-describedby');}
 }
 errorSummary.textContent=count?ui[27]:'';
 errorSummary.hidden=!count;
}
form.addEventListener('invalid',event=>{
 event.preventDefault();validationAttempted=true;showFieldErrors();
 if(!validationFocusQueued){validationFocusQueued=true;queueMicrotask(()=>{validationFocusQueued=false;errorSummary.focus();});}
},true);
for(const eventName of ['input','change'])form.addEventListener(eventName,()=>{if(validationAttempted)showFieldErrors();});

let turnstileToken='', verificationId='', widgetId=null;
const challenge=el('div','',{'aria-label':ui[5]});
button.before(challenge);button.disabled=true;
const resetChallenge=()=>{turnstileToken='';button.disabled=true;if(widgetId!==null)window.turnstile.reset(widgetId);};
const renderChallenge=()=>{
 widgetId=window.turnstile.render(challenge,{sitekey:config.turnstileSiteKey,action:'wildwood_'+config.kind,
 callback:token=>{turnstileToken=token;verificationId=crypto.randomUUID();if(!pending&&!complete)button.disabled=false;},
 'expired-callback':()=>{turnstileToken='';if(!pending)resetChallenge();},
 'error-callback':()=>{turnstileToken='';button.disabled=true;message.textContent=ui[6];}
 });
};
if(window.turnstile)renderChallenge();else{
 const script=document.createElement('script');script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.async=true;script.onload=renderChallenge;
 script.onerror=()=>{message.textContent=ui[6];};document.head.append(script);
}

form.addEventListener('submit',async event=>{
 event.preventDefault();if(pending||complete)return;
 if(!turnstileToken){message.textContent=ui[7];return;}
 if(!submitted){
   if(!form.reportValidity())return;
   const data=Object.fromEntries(new FormData(form));
   for(const [key,,,type] of config.fields){
     if(type!=='dob')continue;
     const parts=['day','month','year'].map(part=>data[key+'-'+part]||'');
     if(parts.some(Boolean)&&!parts.every(Boolean)){message.textContent=ui[10];return;}
     if(parts.every(Boolean)){
       const d=new Date(Date.UTC(+parts[2],months.indexOf(parts[1]),+parts[0]));
       if(d.getUTCDate()!==+parts[0]||d.getUTCMonth()!==months.indexOf(parts[1])||d>new Date()){message.textContent=ui[11];return;}
       data[key]=parts.join(' ');
     }
     for(const part of ['day','month','year'])delete data[key+'-'+part];
   }
   const changeKeys=kind==='spell_change'?['recipientName','dob','poiName','poiDob','newEmail','intention','other']:kind==='reading_change'?['question1','question2','question3','newEmail','other']:null;
   if(changeKeys&&!changeKeys.some(key=>(data[key]||'').trim())){message.textContent=ui[40];message.focus();return;}
   submitted={...data,form:config.kind,requestId};
 }
 pending=true;button.disabled=true;button.textContent=ui[9];message.textContent='';
 for(const input of fields.querySelectorAll('input,select,textarea'))input.disabled=true;
 const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),45000);
 try{
   const response=await fetch(config.endpoint,{method:'POST',body:new URLSearchParams({...submitted,turnstileToken,verificationId}),signal:controller.signal,credentials:'omit',referrerPolicy:'no-referrer'});
   const result=await response.json();
   if(!response.ok||result.ok!==true||result.reference!==requestId){
     const known={
       invalid_form:ui[0],
       verification_required:ui[1],
       verification_unavailable:ui[2],
       reference_conflict:ui[3]
     };
     const error=new Error('Not confirmed');
     error.code=result.code;
     error.friendly=known[result.code];
     throw error;
   }
   complete=true;form.hidden=true;message.textContent=config.confirmation+ui[14]+requestId+'\n\n'+(result.receiptEmail==='sent'?ui[41]+(submitted.newEmail||submitted.email)+'.':result.receiptEmail==='test_skipped'?ui[42]:ui[43]);
 }catch(error){
   message.textContent=(error.friendly ? error.friendly+ui[4]+requestId : ui[13]+requestId);
   button.textContent=ui[12];
   if(error.code==='invalid_form'){
     submitted=null;
     requestId='WW-'+crypto.randomUUID();
     for(const input of fields.querySelectorAll('input,select,textarea'))input.disabled=false;
     branch();
   }
   resetChallenge();
 }finally{clearTimeout(timer);pending=false;button.disabled=complete||!turnstileToken;message.focus();}
});
}
if(params.get('choose')==='1')showChoices();
else if(Object.prototype.hasOwnProperty.call(configs,requested))start(requested);
else if(Object.prototype.hasOwnProperty.call(configs,starting))start(starting);
else if(starting==='recast')start('spell_recast');else showChoices();
})();
